/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EAggregateType } from './EAggregateType';
import {
    EAggregateTypeFromJSON,
    EAggregateTypeFromJSONTyped,
    EAggregateTypeToJSON,
} from './EAggregateType';

/**
 * 
 * @export
 * @interface AggregateKeyInfo
 */
export interface AggregateKeyInfo {
    /**
     * 
     * @type {string}
     * @memberof AggregateKeyInfo
     */
    key?: string | null;
    /**
     * 
     * @type {EAggregateType}
     * @memberof AggregateKeyInfo
     */
    aggregateType?: EAggregateType;
    /**
     * 
     * @type {string}
     * @memberof AggregateKeyInfo
     */
    text?: string | null;
}

/**
 * Check if a given object implements the AggregateKeyInfo interface.
 */
export function instanceOfAggregateKeyInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AggregateKeyInfoFromJSON(json: any): AggregateKeyInfo {
    return AggregateKeyInfoFromJSONTyped(json, false);
}

export function AggregateKeyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AggregateKeyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'aggregateType': !exists(json, 'aggregateType') ? undefined : EAggregateTypeFromJSON(json['aggregateType']),
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function AggregateKeyInfoToJSON(value?: AggregateKeyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'aggregateType': EAggregateTypeToJSON(value.aggregateType),
        'text': value.text,
    };
}

